<template>
    <div>
        <v-container fluid class="pa-0 mt-3">
            <v-row>
                <v-col class="py-0">
                    <v-card variant="flat" tile color="#0d2154">
                        <v-carousel height="220" :show-arrows="false" hide-delimiter-background hide-delimiters>
                            <v-carousel-item tile min-width="1162" aspect-ratio="0.0192307" :src="imgUrl_contactUs"
                                height="100%" width="100%">
                                <div class="general-carousel-heading">
                                    <LanguagePlaceholder is-html
                                        default-text="Contact Us" />
                                </div>
                                <div class="carousel-banner banner-line" style="background-color: #0672cb;"></div>
                            </v-carousel-item>
                        </v-carousel>
                    </v-card>

                </v-col>
            </v-row>
            <v-row no-gutters="" justify="center" style="background-color: #cbeeff;">
                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <v-container>
                        <div class="body-text">
                            <p>
                                <LanguagePlaceholder default-text="For queries or questions about the RISE program please visit our Help Center. We encourage you to check the FAQs, guides and videos as these may help answer your inquiry." />
                            </p>
                            <br>
                            <p>
                                <LanguagePlaceholder default-text="One of the team members will be in contact to provide you with an update or a resolution, within 48 business hours." />
                            </p>
                            <br>
                            <p>
                                <v-btn @click="systemStore.routerTo('faq')" class="text-none" color="#0566b6">
                                    <LanguagePlaceholder
                                        default-text="Help Center" />
                                </v-btn>
                            </p>
                            <p>
                                <!-- <apexchart width="500" type="bar" :options="options" :series="series"></apexchart> -->
                            </p>
                        </div>

                    </v-container>
                </v-col>
                <v-col cols="0" sm="2"></v-col>
            </v-row>
            <v-row no-gutters="" justify="center" style="background-color: #ffffff;">
                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <v-container>
                        <div class="body-text">
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <div class="general-heading">
                                        <LanguagePlaceholder 
                                            default-text="Query Form" />
                                    </div>
                                </v-col>
                                <!-- <v-col cols="12" sm="6">
                                    <div class="float-right">
                                        <LanguagePlaceholder code="34263CF0-5E92-448B-BB96-14E85D19116C"
                                            default-text="* Mandatory Fields" />
                                    </div>
                                </v-col> -->
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field readonly v-model="name" variant="outlined">
                                        <template v-slot:label>
                                            <LanguagePlaceholder 
                                                default-text="Name" />
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field readonly v-model="email" variant="outlined">
                                        <template v-slot:label>
                                            <LanguagePlaceholder 
                                                default-text="Email" />
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field readonly v-model="organizationName" variant="outlined">
                                        <template v-slot:label>
                                            <LanguagePlaceholder 
                                                default-text="Organization Name" />
                                        </template>
                                    </v-text-field>


                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field readonly v-model="affinityId" variant="outlined">
                                        <template v-slot:label>
                                            <LanguagePlaceholder 
                                                default-text="Affinity ID" />
                                        </template>
                                    </v-text-field>

                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <!-- https://stackoverflow.com/questions/75741666/vselect-selection-not-working-with-custom-item-slot-in-vuetify-3 -->
                                    <v-select v-model="queryCategory" :items="queryCategories" variant="outlined">
                                        <template #item="{ item, props: { onClick, title, value } }">
                                            <v-list-item @click="onClick">
                                                <v-list-item-title>
                                                    <LanguagePlaceholder
                                                        :default-text="title.defaultText" />

                                                </v-list-item-title>
                                            </v-list-item>
                                        </template>
                                        <template v-slot:selection="{ item }">
                                            <LanguagePlaceholder
                                                :default-text="item.value.defaultText" />

                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea v-model="message" variant="outlined">
                                        <template v-slot:label>
                                            <LanguagePlaceholder 
                                                default-text="Message" />
                                        </template>
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn @click="clickSubmitQuery" width="100" class="text-none" color="#0566b6">
                                        <LanguagePlaceholder 
                                            default-text="Submit" />
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </v-col>
                <v-col cols="0" sm="2"></v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import imgUrl_contactUs from '@/assets/img/banner/blue_contactus.jpg'

const systemStore = useSystemStore()
const queryCategories = [
    { id: 1, defaultText: 'General Enquiry' },
    { id: 2, defaultText: 'Account Administration' },
    { id: 3, defaultText: 'RISE Credit Notes' },
    { id: 4, defaultText: 'Missing Sales' },
    { id: 5, defaultText: 'Redemption' },
    { id: 6, defaultText: 'E-Voucher' },
    { id: 7, defaultText: 'General' },
    { id: 8, defaultText: 'Other' },

]

const name = ref('')
const email = ref('')
const organizationName = ref('')
const affinityId = ref('')
const queryCategory = ref('')
const message = ref('')

const year = ref(1999)
const yvalue = ref(100)
const to = ref(0)
const count = ref(0)

onMounted(() => {
    renderChart()

    name.value = systemStore.userDetail.fullname
    email.value = systemStore.userDetail.emailAddress
    organizationName.value = systemStore.userDetail.organizationName
    affinityId.value = systemStore.userDetail.affinityId

})

const onClick = (itm) => {
    var t = itm
}

const clickSubmitQuery = () => {
    systemStore.sendContactUsEmail(queryCategory.value.defaultText, message.value).then(res => {
        systemStore.showMessage('Query successfully submitted.', { color: 'success' })
        queryCategory.value = ''
        message.value = ''
    }).catch(error => {
        systemStore.showMessage('Send query failed.', { color: 'error' })
    })
}

const options = ref({
    chart: {
        id: 'vuechart-example'
    },
    xaxis: {
        categories: []
    }
})

const series = ref([{
    name: 'series-1',
    data: []
},
{
    name: 'series-2',
    data: []
}])



const renderChart = () => {
    to.value = setInterval(() => {
        options.value.xaxis.categories.push(year.value)
        year.value++

        var rnd = Math.floor(Math.random() * 100)
        series.value[0].data.push(rnd)

        var rnd1 = Math.floor(Math.random() * 100)
        series.value[1].data.push(rnd1)

        count.value++

        if (count.value > 5) {
            clearInterval(to.value)
        }
    }, 1000);

    //     updateChart() {
    //    const max = 90;
    //    const min = 20;
    //    const newData = this.series[0].data.map(() => {
    //      return Math.floor(Math.random() * (max - min + 1)) + min
    //    })
    //    // In the same way, update the series option
    //    this.series = [{
    //     data: newData
    //    }]
    //   }
    //  }
}
</script>
